export default (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;
